export * from '@primeuix/themes/lara/inputchips';
export { default } from '@primeuix/themes/lara/inputchips';
